import SharedView, { type SharedViewSlide } from "../../sharedComponents/viewIndex"
import DownloadView from "./downloadView"

const DoduWatchIndex = () => {
    const slides: SharedViewSlide[] = [
        {
            id: "spring",
            label: <><span className="text-[#2f6c5c]">DODU</span> WATCHFACE SPRING</>,
            viewComponent: <DownloadView type="spring" />,
            isAvailable: true,
        },
        {
            id: "summer",
            label: <><span className="text-[#2f6c5c]">DODU</span> WATCHFACE SUMMER</>,
            viewComponent: <DownloadView type="summer" />,
            isAvailable: true,
        },
        {
            id: "night",
            label: <><span className="text-[#2f6c5c]">DODU</span> WATCHFACE NIGHT </>,
            // viewComponent: <DownloadView type="night" />,
            viewComponent: null,
            isAvailable: false,
        },
        {
            id: "autumn",
            label: <><span className="text-[#2f6c5c]">DODU</span> WATCHFACE AUTUMN</>,
            // viewComponent: <DownloadView type="autumn" />,
            viewComponent: null,
            isAvailable: false,
        },
        {
            id: "winter",
            label: <><span className="text-[#2f6c5c]">DODU</span> WATCHFACE WINTER</>,
            // viewComponent: <DownloadView type="winter" />,
            viewComponent: null,
            isAvailable: false,
        },
    ]

    return (
        <SharedView slides={slides} />
    )
}

export default DoduWatchIndex
